import { useEffect } from 'react';

import { AccommodationArrangedStatusEnum, AccommodationTypeStatusEnum } from 'types';

import { AccommodationTypeArranged } from './components/AccommodationTypeArranged';
import { IAccommodationStatus } from '../../../../../../../../types';

interface IProps {
  status: IAccommodationStatus;
  setComplete: (status: boolean) => void;
  showWarning: boolean;
  setShowWarning: (status: boolean) => void;

  selectedAccommodationArrangedStatus: {
    status: AccommodationArrangedStatusEnum;
  };
  selectedAccommodationTypeStatus: {
    status: AccommodationTypeStatusEnum;
    setStatus: (status: AccommodationTypeStatusEnum) => void;
  };
  universityAccommodationEnabled: boolean;
}

export const AdditionalQuestions = (props: IProps) => {
  const {
    status,
    selectedAccommodationArrangedStatus: { status: accommodationArrangedStatus },
    selectedAccommodationTypeStatus: { status: accommodationTypeStatus, setStatus },
    setComplete,
    showWarning,
    setShowWarning,
    universityAccommodationEnabled
  } = props;
  useEffect(() => {
    if (
      accommodationArrangedStatus !== AccommodationArrangedStatusEnum.NONE &&
      accommodationTypeStatus !== AccommodationTypeStatusEnum.NONE && // disables submit button
      (status.arrangedStatus !== accommodationArrangedStatus || // prevents setting status to same value
        status.typeStatus !== accommodationTypeStatus) && // prevents setting status to same value
      !(
        // this will be set completed by AccommodationTypeArranged
        [AccommodationTypeStatusEnum.I_DONT_KNOW, AccommodationTypeStatusEnum.OTHER].includes(accommodationTypeStatus)
      ) &&
      !showWarning
    ) {
      setComplete(true);
    }
  }, [setComplete, status, accommodationTypeStatus, accommodationArrangedStatus, showWarning]);

  if (accommodationArrangedStatus !== AccommodationArrangedStatusEnum.NONE) {
    return (
      <AccommodationTypeArranged
        additionalAnswers={{ setStatus }}
        setComplete={setComplete}
        showWarning={showWarning}
        setShowWarning={setShowWarning}
        accommodationTypeStatus={accommodationTypeStatus}
        isArranged={accommodationArrangedStatus === AccommodationArrangedStatusEnum.ARRANGED}
        universityAccommodationEnabled={universityAccommodationEnabled}
      />
    );
  }

  return <></>;
};
